// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"303":"component---node-modules-bufox-gatsby-theme-parkio-src-pages-404-js","579":"component---node-modules-bufox-gatsby-theme-parkio-src-pages-index-js"}[chunkId] || chunkId) + "-" + {"108":"4217e82c17e4da122044","303":"be55c7f58ddae30d6c01","452":"a511fb2eb7584c8ea9a4","579":"6ddfd52c97936befca2c"}[chunkId] + ".js";
};